import { createContext, useContext } from "react";
import useAxios from "../Utils/useAxios";
import { handleError, handleSuccess } from "../Utils/externalFunctions";
import { getItemSubmitSuccessMsg } from "../Constant/Message";

const KalenderContext = createContext();

export const useKalender = () => useContext(KalenderContext);

export const KalenderProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getEvent: () => 
      axiosInstance.get("kalender/")
        .catch(err => handleError(err, "GET Event")),
    
    getEventByPeriod: (periode) => 
      axiosInstance.get(`kalender/${periode}`)
        .catch(err => handleError(err, "GET Event")),
    
    updateEvent: (formData) => 
      axiosInstance.post("kalender/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(res => handleSuccess(res, getItemSubmitSuccessMsg("Kalender")))
      .catch(err => handleError(err, "POST Kalender")),
    
    getTemplateKalender: () => 
      axiosInstance.get("/dokumen/template-kalender/", {
        responseType: "blob",
      })
      .then(res => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "kalender_template.xlsx";
        if (contentDisposition && contentDisposition.includes("filename=")) {
          filename = contentDisposition
            .split("filename=")[1]
            .replace(/['"]/g, "");
        }
        const contentType = res.headers["content-type"] || "application/octet-stream";
        const file = new Blob([res.data], { type: contentType });
        const fileURL = URL.createObjectURL(file);
        const dom = document.createElement("a");
        dom.setAttribute("style", "display:none");
        dom.setAttribute("href", fileURL);
        dom.setAttribute("target", "_blank");
        dom.setAttribute("download", filename);
        document.body.appendChild(dom);
        dom.click();
        document.body.removeChild(dom);
        return handleSuccess(res, "File berhasil diunduh!");
      })
      .catch(err => handleError(err, "GET Template Kalender"))
  };

  return (
    <KalenderContext.Provider value={api}>
      {children}
    </KalenderContext.Provider>
  );
};

export default KalenderContext;